import React from 'react';
import { useRouter } from 'next/router';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useTranslation } from 'next-i18next';

const HCaptchaComponent = ({ siteKey, error, onVerify, onExpire }) => {
    const { t } = useTranslation('');
    const { locale } = useRouter();
    if (!siteKey)
        return null;
    return (React.createElement("div", { className: "h-captcha" },
        React.createElement(HCaptcha, { sitekey: siteKey, languageOverride: locale, onVerify: (token) => onVerify(token), onExpire: onExpire }),
        error && (React.createElement("div", { className: "error", role: "alert" }, t(error)))));
};

export { HCaptchaComponent as H };
//# sourceMappingURL=HCaptcha-z_AMrNS9.js.map
